import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        showCorrectAnswers: '=',
        formSubmission: '=',
        showPointsAwarded: '='
    },
    template: `
        <div class="alert alert-danger" ng-if="vm.form.answers[vm.question.id].errors.answerId"
            >{{ vm.form.answers[vm.question.id].errors.answerId }}</div>
        <div class="heading01">
            <div class="question-title" ng-bind-html="vm.getQuestionName() | isRequired: vm.question.formQuestions[0].isRequired"></div>
            <ul class="metablock" ng-if="vm.showPointsAwarded">
                <li>
                    <div class="label">{{ 'quiz.Points awarded' | translate }}</div>
                    <div class="value">{{ vm.getPointsObtained() }} / {{ vm.question.score }}</div>
                </li>
            </ul>
        </div>
        <div class="checkboxes06">
            <ul>
                <li ng-repeat="answer in vm.question.questionAnswers">
                    <input type="radio" ng-model="vm.answer.answerId" ng-change="vm.onChange()" ng-value="answer.id" name="question-{{ vm.question.id }}">
                    <label> {{ answer.text }}</label>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor (lodash) {
        this.lodash = lodash;
        this.answer = {
            id: lodash.get(this.question, 'submittedAnswer.id', null),
            questionId: this.question.id,
            language: 'et',
            answerId: lodash.get(this.question, 'submittedAnswer.answerId', null)
        };
        this.form.answers[this.question.id] = this.answer;
    }

    getPointsObtained () {
        let points = 0;
        this.lodash.forEach(this.formSubmission.formSubmissionAnswers, fsAnswer => {
            if (fsAnswer.questionId === this.question.id) {
                points += fsAnswer.points;
            }
        });

        if (points < 0) {
            points = 0;
        }

        return points;
    }

    getQuestionName () {
        if (this.isTrial) {
            return this.question.questionI18ns[this.selectedLanguage] ?
                this.question.questionI18ns[this.selectedLanguage].name :
                this.question.questionI18ns[this.defaultLanguage].name;
        }

        return this.question.activeI18n.name;
    }

    onChange () {
        this.form.answers[this.question.id] = this.answer;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/question/scale/index.js